import { Box } from '@material-ui/core';

import { TWindowType } from '../../interfaces';

import { useStyles } from './style';

export const Nav = ({ type }: { type: TWindowType }) => {
  const classes = useStyles();
  const changeActiveTab = () => {
    //@ts-ignore (use ts-ignore because this method is missing from the declaration)
    window.connect.core.activateChannelWithViewType('home', type);
  };

  return <Box className={classes.nav} onClick={changeActiveTab}></Box>;
};
